import {isMobile, isTablet} from 'react-device-detect';

export const isEditorMobileVariant = (): boolean => {
  if (isTablet) {
    return false;
  }

  return isMobile;
};
